import { Component, OnInit } from '@angular/core';
import { SubcategoryService } from '../../shared/subcategory.service';
import { AngularFirestore } from '@angular/fire/firestore';
import { ToastrService } from 'ngx-toastr';
import { NgForm } from '@angular/forms';
import { Category } from '../../shared/category.model';
import { CategoryService } from '../../shared/category.service';
import { Stores } from '../../shared/stores.model';
import { StoresService } from '../../shared/stores.service';
import { Subcategory } from '../../shared/subcategory.model';

@Component({
  selector: 'app-subcategory',
  templateUrl: './subcategory.component.html',
  styleUrls: ['./subcategory.component.css']
})
export class SubcategoryComponent implements OnInit {

  categorys: Category[];
  stores: Stores[];

  constructor(private service : SubcategoryService,
    private categoryService:CategoryService,
    private storeService:StoresService,
    private firestore : AngularFirestore,
    private toastr :ToastrService) { }

  ngOnInit() {
    this.resetForm();
    this.categoryService.getCategory().subscribe(actionArray =>{
      this.categorys = actionArray.map(item => {
        const data = item.payload.doc.data() as Category;
        const id = item.payload.doc.id;
        return { id, ...data };
      })
    });

    this.storeService.getStores().subscribe(actionArray =>{
      this.stores = actionArray.map(item => {
        const data = item.payload.doc.data() as Stores;
        const id = item.payload.doc.id;
        return { id, ...data };
      })
    });
  }
  
  resetForm(form? : NgForm){
    if(form != null)
      form.resetForm();
    this.service.subcategoryData = {
      id : null,
      name : '',
      category : '',
      order : null,
      store : '',
      status : '',
      
    }
  }

  onSubmit(form:NgForm){
    let data = Object.assign({}, form.value)
    data.order = Number(data.order)
    delete data.id;
    if(form.value.id == null)
      this.firestore.collection('subCategory').add(data);
    else
      this.firestore.doc('subCategory/' + form.value.id).update(data)
    this.resetForm(form);
    this.toastr.success('Submitted Successfully','Sub Category')
  }

}
